import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68588ae1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "borrow-applyDetail" }
const _hoisted_2 = { class: "open-matters-approve" }
const _hoisted_3 = { class: "intro-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "intro-item-label" }, [
  /*#__PURE__*/_createTextVNode("公司类型："),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_5 = { class: "intro-item-value text-overflow" }
const _hoisted_6 = { class: "intro-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "intro-item-label" }, [
  /*#__PURE__*/_createTextVNode("选定城市："),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_8 = { class: "intro-item-value" }
const _hoisted_9 = { class: "intro-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "intro-item-label" }, [
  /*#__PURE__*/_createTextVNode("预计开业时间："),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_11 = { class: "intro-item-value" }
const _hoisted_12 = { class: "open-matters-approve" }
const _hoisted_13 = { class: "intro-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "intro-item-label" }, [
  /*#__PURE__*/_createTextVNode("对接会计："),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_15 = { class: "intro-item-value" }
const _hoisted_16 = { class: "intro-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "intro-item-label" }, [
  /*#__PURE__*/_createTextVNode("对接出纳："),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_18 = { class: "intro-item-value" }

import {
  ref,
  onMounted,
  withDefaults,
  watch,
} from "vue";
import HeadTitle from "@/components/HeadTitle.vue";
import { companyBusiness } from "@/api/openapply";


export default /*#__PURE__*/_defineComponent({
  props: {
    folwId: { default: 0 },
    update: { type: Boolean, default: false }
  },
  emits: ["change-status", "change-dock", "change-flow-id"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { folwId: number, update: boolean }




const TypeName = ref<string>("");
const CityName = ref<string>("");
const ExpectOpenTime = ref<string>("");
const DockingCashierName = ref<string>("");
const DockingAccountingName = ref<string>("");
const DockingCashier = ref<string>("");
const DockingAccounting = ref<string>("");

watch(
  () => props.update,
  (val, oldval) => {
    if (val != oldval) {
      getdata();
    }
  }
);
const getdata = async () => {
  const { Data } = await companyBusiness({
    Id: props.folwId,
  });
  TypeName.value = Data?.TypeName || "";
  CityName.value = Data?.CityName || "";
  ExpectOpenTime.value = Data?.ExpectOpenTime || "";
  DockingCashierName.value =
    Data?.DockingCashierName == "0" ? "" : Data?.DockingCashierName;
  DockingAccountingName.value =
    Data?.DockingAccountingName == "0" ? "" : Data?.DockingAccountingName;
  DockingCashier.value =
    Data?.DockingCashier == "0" ? "" : Data?.DockingCashier;
  DockingAccounting.value =
    Data?.DockingAccounting == "0" ? "" : Data?.DockingAccounting;
  $emit("change-dock", {
    DockingCashier: DockingCashier.value,
    DockingAccounting: DockingAccounting.value,
    DockingCashierName: DockingCashierName.value,
    DockingAccountingName: DockingAccountingName.value,
  });
  $emit("change-status", {
    buttons: Data?.ActionButtons,
    flowId: Data?.WorkFlowId,
    id: props.folwId,
    ApplicationInfo:Data?.ApplicationInfo,
    ApplicationTime:Data?.ApplicationTime
  });
};
onMounted(async () => {
  getdata();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeadTitle, {
      title: "开业申请事项",
      style: {"margin-top":"24px"}
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, _toDisplayString(TypeName.value), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, _toDisplayString(CityName.value), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(ExpectOpenTime.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, _toDisplayString(DockingAccountingName.value
              ? DockingAccountingName.value
              : "(待集团财务部门设置)"), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, _toDisplayString(DockingCashierName.value ? DockingCashierName.value : "(待集团财务部门设置)"), 1)
        ])
      ])
    ])
  ], 64))
}
}

})